export function getSoldQuantityFactor(
    qtd = 0,
    unit?: string,
    total = 0,
    price = 0,
) {
    const quantity = Number(qtd) || 0;
    const normalizedUnit = unit?.toUpperCase();

    if (normalizedUnit !== 'KG' || quantity <= 0) return 1;

    const totalValue = Number(total) || 0;
    const unitPrice = Number(price) || 0;
    const averagePrice = totalValue / quantity;

    if (quantity >= 10 && unitPrice > 0 && averagePrice > 0 && averagePrice < unitPrice / 10) {
        return 0.001;
    }

    return 1;
}

export function normalizeSoldQuantity(
    qtd = 0,
    unit?: string,
    total = 0,
    price = 0,
) {
    const quantity = Number(qtd) || 0;
    return Number((quantity * getSoldQuantityFactor(quantity, unit, total, price)).toFixed(3));
}